module.exports = __webpack_public_path__ + "static/media/cart.ac92f8fe.png";